import { animeList, categories } from "@/mocks/anime";
import type { Anime, AnimeCategory } from "@/types/anime";

export function getCategoryById(id: string): AnimeCategory | undefined {
  return categories.find((c) => c.id === id);
}

export function categoryIdFromName(name: string): string {
  return categories.find((c) => c.name === name)?.id ?? "hotblood";
}

export function getAnimeById(id: string): Anime | undefined {
  return animeList.find((a) => a.id === id);
}

export function formatHeat(heat: number): string {
  if (heat >= 10000) {
    return `${(heat / 10000).toFixed(1)}w`;
  }
  return `${heat}`;
}

export interface FilterOptions {
  region?: string;
  year?: string;
  sort?: string;
}

export function filterAnime(
  list: Anime[],
  categoryName: string | null,
  options: FilterOptions,
): Anime[] {
  const { region, year, sort } = options;
  let result = categoryName ? list.filter((a) => a.category === categoryName) : [...list];

  if (region && region !== "全部") {
    result = result.filter((a) => a.region === region);
  }
  if (year && year !== "全部") {
    result = result.filter((a) => String(a.year) === year);
  }

  switch (sort) {
    case "heat":
      result = [...result].sort((a, b) => b.heat - a.heat);
      break;
    case "rating":
      result = [...result].sort((a, b) => b.rating - a.rating);
      break;
    default:
      result = [...result].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  }

  return result;
}

export function searchAnime(list: Anime[], keyword: string, sort: string): Anime[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  const matched = list.filter(
    (a) =>
      a.title.toLowerCase().includes(q) ||
      a.category.toLowerCase().includes(q) ||
      a.tags.some((t) => t.toLowerCase().includes(q)) ||
      a.summary.toLowerCase().includes(q),
  );

  if (sort === "update") {
    return [...matched].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  }
  if (sort === "rating") {
    return [...matched].sort((a, b) => b.rating - a.rating);
  }
  return matched;
}

export function getRelatedAnime(current: Anime, limit = 4): Anime[] {
  return animeList
    .filter((a) => a.id !== current.id && a.category === current.category)
    .slice(0, limit);
}

export function getHotAnime(limit = 8): Anime[] {
  return [...animeList].sort((a, b) => b.heat - a.heat).slice(0, limit);
}

export function getLatestAnime(limit = 9): Anime[] {
  return [...animeList]
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .slice(0, limit);
}